import React from 'react';
import { IPhoneFrame } from "../components/IPhoneFrame.tsx";

export const Home = () => (
  <div id="home" className="section rt-hero overflow-hidden">
    <div className="container rt-hero-container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="rt-hero-content">
            <div className="rt-eyebrow">RepTool</div>
            <h1 className="rt-hero-title">For keepers of any scale.</h1>
            <p className="rt-hero-subtitle">
              Track your collection, plan pairings, and explore genetics with fast, clean tools designed for reptile
              keepers.
            </p>
            <div className="rt-hero-ctas">
              <a className="btn rt-btn-secondary" href="#about">Learn more</a>
              <a className="btn rt-btn-primary" href="https://reptool.app/app/">Open RepTool</a>
            </div>
            <div className="rt-store-row">
              <a href="https://reptool.app/play_store" target="_blank" rel="noreferrer">
                <img src="img/play-btn.png" className="app-store-btn rt-store-btn" alt="Get it on Google Play" />
              </a>
              <a href="https://reptool.app/app_store" target="_blank" rel="noreferrer">
                <img src="img/app-btn.png" className="app-store-btn rt-store-btn" alt="Download on the App Store" />
              </a>
            </div>
            <div className="rt-mini-features">
              <div className="rt-mini-card">
                <div className="rt-mini-title">Genetics</div>
                <div className="rt-mini-text">Calculator + morph library</div>
              </div>
              <div className="rt-mini-card">
                <div className="rt-mini-title">Records</div>
                <div className="rt-mini-text">Feeding, weight, notes, history</div>
              </div>
              <div className="rt-mini-card">
                <div className="rt-mini-title">Collection</div>
                <div className="rt-mini-text">Organize animals your way</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="rt-device-stage">
            <IPhoneFrame
              screenshotSrc="img/gene-calc-screen.png"
              screenshotAlt=""
              className="rt-hero-iphone"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
)